import _ from 'lodash';
import AppRestService from './app-rest.service';
import ImdbHtmlParser from './imdb-html-parser';
import ImdbGraphQLParser from './imdb-graphql-parser';



/**
 * Service Endpoint Implementation
 */
export default class ImdbService extends AppRestService {

  constructor(opts = null) {
    super(opts);
    this.serviceName = 'imdb';
    this.routePath = 'imdb';
    this.modelClass = null;
    this.authEnabled = true;
    // this.auth = true;
  }

  async getMovieData(imdbId) {
    // Use IMDB's GraphQL API (bypasses AWS WAF that blocks HTML scraping)
    try {
      let graphqlPath = [this.routePath, '/graphql/id/' + imdbId + '/'];
      let res = await this.request.getRawRequest(graphqlPath);
      let graphqlData = _.get(res, 'data.data.body', null);
      if (graphqlData && _.get(graphqlData, 'data.title')) {
        let parser = new ImdbGraphQLParser(graphqlData, imdbId);
        return parser.parseAll();
      }
    } catch (ex) {
      console.warn('IMDB GraphQL request failed, falling back to HTML scraping: ', ex);
    }

    // Fallback: HTML scraping (may be blocked by AWS WAF)
    let path = [this.routePath, '/html/title/' + imdbId + '/'];
    let res = await this.request.getRawRequest(path);
    let rawHtml = _.get(res, 'data.data.body', null);
    let imdbParser = new ImdbHtmlParser(rawHtml, imdbId);
    return imdbParser.parseAndMergeAll();
  }

  async searchTitles(search) {
    let path = [this.routePath, '/search-titles/' + search + '/'];
    let res = await this.request.getRawRequest(path);
    return _.get(res, 'data', null);
  }

  async searchNames(search) {
    let path = [this.routePath, '/search-names/' + search + '/'];
    let res = await this.request.getRawRequest(path);
    return _.get(res, 'data', null);
  }

  async getSuggestedTitles(search) {
    let path = [this.routePath, '/suggest-titles/' + search + '/'];
    let res = await this.request.getRawRequest(path);
    return _.get(res, 'data.body.d', null);
  }

  async getFirstTitleSuggestion(search) {
    return null;

    /*
    return this.getSuggestedTitles(search).map(suggestData => {
      let firstItem: any = _.first(suggestData);
      let movieId: string = _.get(firstItem, 'id', null);
      if (!movieId) { return null; }
      return this.getMovie(movieId) as Observable<ImdbMovie>;
    }); //*/
  }

  _tryJsonParse(data, ...args) {
    let retval = data;
    try {
      retval = JSON.parse(data, ...args);
    } catch (ex) { /* noop */ }
    return retval;
  }
}
